<template lang="pug">
AppMapMarker.activities-location-move-marker(
  :z-index="zIndex"
  :marker="marker"
  has-icon
  :icon-size="size"
  is-clickable
  is-hoverable
  :icon-url="moveIconUrl"
  has-info-window
  :show-marker-radius="showRadius"
  :show-info-window="showInfoWindow"
  :info-window-options="infoWindowOptions"
  :circle-options="defaultMarkerCircleOptions"
  @info-window="$emit('info-window', $event)"
  @close-info="$emit('close-info', $event)"
)
  template(#infoWindow)
    .app-map-move-marker-info-window
      | Recorded at: {{ recordedAt }}
</template>

<script>
import { activitiesMarker } from '~/mixins';
import { ICON_MARKER_MOVE } from '~/rails_assets';
import { formatTime } from '~/utils/time_utils';
import { mapGetters } from 'vuex';

export default {
  name: 'ActivitiesLocationMoveMarker',
  mixins: [activitiesMarker({ zIndex: 2 })],
  computed: {
    ...mapGetters(['activeTimeZoneName']),
    moveIconUrl: () => ICON_MARKER_MOVE,
    infoWindowOptions: () => ({ pixelOffset: { width: 0, height: -6 } }),
    recordedAt() {
      return formatTime(this.marker.recorded_at, { showSeconds: 'never', timezone: this.activeTimeZoneName });
    },
  },
};
</script>
